var path = '/app/pages/account/account.html';
var html = "<div class=container style=min-height:440px> <ui-view></ui-view> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/account.html
// module id = 1117
// module chunks = 0